import ApiHelper from '../ApiHelper.js';

const ADP_LIST_API_URL = "/api/adplist";

export default {
    getAPDListProfile: function (profileId) {
        return ApiHelper.get(`${ADP_LIST_API_URL}?profileId=${profileId}`);
    },
}
